export default function UiLoader() {
    return (
        <span className="bi-arrow-clockwise animate__animated animate__spin animate__infinite text-primary fw-bolder" />
    );
}
